import { render, staticRenderFns } from "./ZhuantiMapBlock.vue?vue&type=template&id=bd1eb1ee&scoped=true"
import script from "./ZhuantiMapBlock.vue?vue&type=script&lang=js"
export * from "./ZhuantiMapBlock.vue?vue&type=script&lang=js"
import style0 from "./ZhuantiMapBlock.vue?vue&type=style&index=0&id=bd1eb1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd1eb1ee",
  null
  
)

export default component.exports